import { Action } from 'typescript-fsa';
import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import { RecipeState } from '../../entities/recipes/recipes.reducer';
import { clearPreview, previewEditFeedGroup, setEditGroup, setUseLockedFeedings } from './groupPreview.actions';
import { FeedGroupCreationPreview } from './groupPreview.types';

export type AppFeedGroupState = {
  readonly feedGroupCreationPreview: FeedGroupCreationPreview;
  readonly useLockedFeedings: boolean;
  readonly isEditMode: boolean;
};

export const initialState: AppFeedGroupState = {
  feedGroupCreationPreview: {
    actualWeightHead: 0,
    dryWeightHead: 0,
    finalPriceHead: 0,
    numberOfCows: 0,
    feedings: [],
  } as any,
  isEditMode: false,
  useLockedFeedings: false,
};

const appFeedGroupReducer = createReducer(initialState, {
  [setEditGroup.type]: (state: AppFeedGroupState, action: Action<typeof setEditGroup.type>) => {
    return {
      ...state,
      isEditMode: true,
      feedGroupCreationPreview: action.payload,
    };
  },
  [previewEditFeedGroup.done.type]: (
    state: AppFeedGroupState,
    action: Action<{ result: FeedGroupCreationPreview }>,
  ) => {
    return dotProp.set(state, 'feedGroupCreationPreview', action.payload.result);
  },
  [clearPreview.type]: () => {
    return {
      feedGroupCreationPreview: {
        actualWeightHead: 0,
        dryWeightHead: 0,
        finalPriceHead: 0,
        numberOfCows: 0,
        feedings: [],
      },
      useLockedFeedings: false,
      isEditMode: false,
    };
  },
  [setUseLockedFeedings.type]: (state: RecipeState, action: Action<boolean>) => {
    return dotProp.set(state, 'useLockedFeedings', action.payload);
  },
});

export default appFeedGroupReducer;
